import './css/parfondbois.pcss';
import './sass/site/master.scss';


require('./feed/resources/js/jquery-template');
require('./feed/resources/js/lwsreviews-feed');


var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');
var imagesLoaded = require('imagesloaded');

jQueryBridget( 'masonry', Masonry, $ );
jQueryBridget( 'imagesLoaded', imagesLoaded, $ );

$(function(){
    var $gridItems = $('.en-images .grid-item');
    $gridItems.hide();

    var $container = $('.en-images .grid');
        $container.imagesLoaded( function() {
        $gridItems.fadeIn();

        $container.masonry({
            columnWidth: '.grid-sizer',
            itemSelector : '.grid-item',
            gutter: 0,
            isFitWidth: false,
        });    

    });

    $('.item-chiffres-slider').slick({
        slidesToShow: 4,
        swipe: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]        
    });

    $('.en-chiffres .fleche-gauche').on('click', function(){
        $('.item-chiffres-slider').slick('slickPrev');
    });

    $('.en-chiffres .fleche-droite').on('click', function(){
        $('.item-chiffres-slider').slick('slickNext');
    });


    $('.scrolldown').on('click',function(){

        $('html, body').animate({
            scrollTop: $(".en-chiffres").offset().top
        }, 1000);
    });
    
    
    $('#burger').on('click',function(){
       $(this,'#site-navigation').toggleClass('active');
       $('#site-navigation').toggleClass('active');
    });

    $('.nav-link').on('click', function(e){
        e.preventDefault();
        var $filteritems = $(this).data('filter');
        var $textfiltre = $(this).data('txt');

        $('.nav-link').removeClass('active');
        $('.grid-item').fadeOut();

        $(this).addClass('active');

        
        console.log($textfiltre);
        $('.toggle_nav').find('span').text($textfiltre);
        $('.grid-item.' + $filteritems).fadeIn();

        $('.toggle_nav').removeClass('active');
        $('.nav-tabs').toggleClass('hidden block');
    });

    $('.toggle_nav').on('click',function(e){
        e.preventDefault();
        
        $(this).toggleClass('active');
        $('.nav-tabs').toggleClass('hidden block');
    });
    
    $('.toggle_tarifs').on('click',function(e){
        e.preventDefault();
        
        $(this).toggleClass('active');
        $(this).next().toggleClass('hidden block');

    });
    $('.nav_tarifs li').on('click', function(e){
        $('.nav_tarifs li').removeClass('active');
        $(this).toggleClass('active');
        var $textfiltre = $(this).text();
        var $activeTarif = $(this).data('tarif');

        $('.toggle_tarifs').removeClass('active');
        $(this).parent().toggleClass('hidden block');
        $(this).parent().prev().find('span').text($textfiltre);

        $('.tarifs_table_mobile:not(#'+ $activeTarif +')').addClass('hidden');
        $('.tarifs_table_mobile#'+ $activeTarif).removeClass('hidden').addClass('grid')
    });
});
